/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CreateEstimationItemRequest,
  EstimationItemResponse,
  RenameEstimationItemRequest,
  UpdateEstimationItemRequest,
  UpsertEstimationItemsRequest,
  V1EstimationItemsDeleteError,
  V1EstimationItemsDetailError,
  V1EstimationItemsNamePartialUpdateError,
  V1EstimationItemsUpdateError,
  V1EstimationsEstimationItemsCreateError,
  V1EstimationsEstimationItemsListError,
  V1EstimationsEstimationItemsPartialUpdateError,
  V1EstimationsInitialEstimationItemsCreateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class EstimationItem<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationsInitialEstimationItemsCreate
   * @request POST:/api/v1/estimations/{estimationId}/initial-estimation-items
   * @secure
   * @response `200` `(EstimationItemResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsInitialEstimationItemsCreate = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemResponse[], V1EstimationsInitialEstimationItemsCreateError>({
      path: `/api/v1/estimations/${estimationId}/initial-estimation-items`,
      method: 'POST',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationsEstimationItemsCreate
   * @request POST:/api/v1/estimations/{estimationId}/estimation-items
   * @secure
   * @response `200` `EstimationItemResponse` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsEstimationItemsCreate = (
    estimationId: string,
    data: CreateEstimationItemRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemResponse, V1EstimationsEstimationItemsCreateError>({
      path: `/api/v1/estimations/${estimationId}/estimation-items`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationsEstimationItemsList
   * @request GET:/api/v1/estimations/{estimationId}/estimation-items
   * @secure
   * @response `200` `(EstimationItemResponse)[]` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsEstimationItemsList = (estimationId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemResponse[], V1EstimationsEstimationItemsListError>({
      path: `/api/v1/estimations/${estimationId}/estimation-items`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationsEstimationItemsPartialUpdate
   * @request PATCH:/api/v1/estimations/{estimationId}/estimation-items
   * @secure
   * @response `200` `(EstimationItemResponse)[]` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationsEstimationItemsPartialUpdate = (
    estimationId: string,
    data: UpsertEstimationItemsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemResponse[], V1EstimationsEstimationItemsPartialUpdateError>({
      path: `/api/v1/estimations/${estimationId}/estimation-items`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationItemsDelete
   * @request DELETE:/api/v1/estimation-items/{estimationItemId}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsDelete = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<void, V1EstimationItemsDeleteError>({
      path: `/api/v1/estimation-items/${estimationItemId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationItemsUpdate
   * @request PUT:/api/v1/estimation-items/{estimationItemId}
   * @secure
   * @response `200` `EstimationItemResponse` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsUpdate = (
    estimationItemId: string,
    data: UpdateEstimationItemRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemResponse, V1EstimationItemsUpdateError>({
      path: `/api/v1/estimation-items/${estimationItemId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationItemsDetail
   * @request GET:/api/v1/estimation-items/{estimationItemId}
   * @secure
   * @response `200` `EstimationItemResponse` OK
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsDetail = (estimationItemId: string, params: RequestParams = {}) =>
    this.http.request<EstimationItemResponse, V1EstimationItemsDetailError>({
      path: `/api/v1/estimation-items/${estimationItemId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags EstimationItem
   * @name V1EstimationItemsNamePartialUpdate
   * @summary Lightweight name-only rename — see EWM-589 / EWM-590. Does not trigger recalculation and is rejected when the estimation is InReview or Approved.
   * @request PATCH:/api/v1/estimation-items/{estimationItemId}/name
   * @secure
   * @response `200` `EstimationItemResponse` OK
   * @response `400` `ValidationProblemDetailsWithErrorCode` Bad Request
   * @response `401` `NoContentResult` Unauthorized
   * @response `404` `ProblemDetailsWithErrorCode` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1EstimationItemsNamePartialUpdate = (
    estimationItemId: string,
    data: RenameEstimationItemRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<EstimationItemResponse, V1EstimationItemsNamePartialUpdateError>({
      path: `/api/v1/estimation-items/${estimationItemId}/name`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
